import { isDevelopmentMode, methods, sendRequest } from "../base";

export const getCMSContents = () => {
  return sendRequest(
    isDevelopmentMode() ? "/cms/system-contents" : "/content/home/"
  );
};

export const getSystemParameters = (commodity_id = 1) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/system-manager/system-parameters?commodity_id=" + commodity_id
      : "/trade/current-wage/"
  );
};

export const getAppVersions = () => {
  return sendRequest(
    isDevelopmentMode() ? "/system-manager/app-version" : "/trade/current-wage/"
  );
};
